export default "/_next/static/assets/Desyrel_2892e6210e13eec4a4c4079b2505b381.ttf";